import { useEffect, useRef, useState } from 'react'

const useWindowFocus = () => {
  const computeFocus = () => {
    if (typeof document === 'undefined') return true

    const visibilityOk = document.visibilityState === 'visible'
    const focusOk =
      typeof document.hasFocus === 'function' ? document.hasFocus() : true

    return visibilityOk && focusOk
  }

  const [isFocus, setIsFocus] = useState<boolean>(computeFocus)
  const lastValueRef = useRef<boolean>(isFocus)

  const setIfChanged = (next: boolean) => {
    if (lastValueRef.current === next) return

    lastValueRef.current = next
    setIsFocus(next)
  }

  useEffect(() => {
    if (typeof document === 'undefined') return

    const syncFocusState = () => {
      setIfChanged(computeFocus())
    }

    syncFocusState()

    document.addEventListener('visibilitychange', syncFocusState)
    window.addEventListener('focus', syncFocusState)
    window.addEventListener('blur', syncFocusState)
    window.addEventListener('pageshow', syncFocusState)
    window.addEventListener('pagehide', syncFocusState)

    return () => {
      document.removeEventListener('visibilitychange', syncFocusState)
      window.removeEventListener('focus', syncFocusState)
      window.removeEventListener('blur', syncFocusState)
      window.removeEventListener('pageshow', syncFocusState)
      window.removeEventListener('pagehide', syncFocusState)
    }
  }, [])

  return isFocus
}

export default useWindowFocus